// Announcements (global or course-scoped). RLS hides course posts from non-enrolled students.
import { supabase } from '../integrations/supabase/client';

export interface Announcement {
  id: string;
  course_id: string | null;
  title: string;
  body: string;
  is_published: boolean;
  created_at: string;
}

export async function listMyAnnouncements(): Promise<Announcement[]> {
  try {
    const { data, error } = await supabase
      .from('announcements')
      .select('*')
      .eq('is_published', true)
      .order('created_at', { ascending: false })
      .limit(20);
    if (error) return [];
    return (data ?? []) as unknown as Announcement[];
  } catch {
    return [];
  }
}

// ---- admin ----
export async function listAnnouncementsAdmin(): Promise<Announcement[]> {
  const { data, error } = await supabase.from('announcements').select('*').order('created_at', { ascending: false }).limit(200);
  if (error) throw new Error(error.message);
  return (data ?? []) as unknown as Announcement[];
}

export async function saveAnnouncementAdmin(input: { title: string; body: string; courseId?: string | null; isPublished?: boolean }) {
  const { error } = await supabase.from('announcements').insert({
    title: input.title.trim(),
    body: input.body.trim(),
    course_id: input.courseId || null,
    is_published: input.isPublished ?? true,
  });
  if (error) throw new Error(error.message);
}

export async function deleteAnnouncementAdmin(id: string) {
  const { error } = await supabase.from('announcements').delete().eq('id', id);
  if (error) throw new Error(error.message);
}
